import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLUE_500, getTestId, isValidObject, RightChevronButtonIcon, Typography, useBreakpoint } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getPackInfoStyles } from './PackInfoStyles';
import { getPackDetailsText, getPriceDetailsText } from './PackInfoUtils';
export var PackInfo = props => {
  var packCardStyles = getPackInfoStyles();
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var id = props.id,
    _props$planInfo = props.planInfo,
    planInfo = _props$planInfo === void 0 ? [] : _props$planInfo,
    _props$hideRightChevr = props.hideRightChevronIcon,
    hideRightChevronIcon = _props$hideRightChevr === void 0 ? true : _props$hideRightChevr,
    onUserAction = props.onUserAction,
    onCardPress = props.onCardPress,
    packInfoStyle = props.packInfoStyle,
    _props$priceDetails = props.priceDetails,
    priceDetails = _props$priceDetails === void 0 ? {} : _props$priceDetails,
    testID = props.testID,
    _props$subTextColor = props.subTextColor,
    subTextColor = _props$subTextColor === void 0 ? BLACK_700 : _props$subTextColor;
  var priceDetailsAccessible = !isValidObject(priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.accessibilityProps);
  return _jsxs(View, Object.assign({
    style: [packCardStyles.container, packInfoStyle]
  }, getTestId(testID, 'packInfoContainer'), {
    children: [_jsxs(View, Object.assign({
      style: packCardStyles.innerContainer
    }, getTestId(testID, 'packInfoInnerContainer'), {
      children: [!!priceDetails && isValidObject(priceDetails) && _jsxs(View, Object.assign({
        style: packCardStyles.planItem
      }, getTestId(testID, 'priceDetailsBox'), priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.accessibilityProps, {
        children: [_jsx(Typography, Object.assign({
          multiText: getPriceDetailsText(isSmallScreen, priceDetails, false, subTextColor)
        }, getTestId(testID, 'priceDetailsText_1'), {
          accessible: priceDetailsAccessible
        })), _jsx(View, {
          style: packCardStyles.priceItemVerticalSpacing
        }), _jsx(Typography, Object.assign({
          multiText: getPriceDetailsText(isSmallScreen, priceDetails, true, subTextColor)
        }, getTestId(testID, 'priceDetailsText_2'), {
          accessible: priceDetailsAccessible
        }))]
      })), (planInfo === null || planInfo === void 0 ? void 0 : planInfo.length) > 0 && (planInfo === null || planInfo === void 0 ? void 0 : planInfo.map((plan, index) => {
        return _jsxs(View, Object.assign({
          style: packCardStyles.planItem
        }, getTestId(testID, "planItemBox"), plan === null || plan === void 0 ? void 0 : plan.accessibilityProps, {
          children: [_jsx(Typography, Object.assign({
            multiText: getPackDetailsText(isSmallScreen, plan)
          }, getTestId(testID, "planItemText_1"), {
            accessible: !isValidObject(plan === null || plan === void 0 ? void 0 : plan.accessibilityProps)
          })), _jsx(View, {
            style: packCardStyles.planItemVerticalSpacing
          }), _jsx(Typography, Object.assign({
            multiText: getPackDetailsText(isSmallScreen, plan, true)
          }, getTestId(testID, "planItemText_2"), {
            accessible: !isValidObject(plan === null || plan === void 0 ? void 0 : plan.accessibilityProps)
          }))]
        }), "plan-item-" + index);
      }))]
    })), !hideRightChevronIcon && _jsx(RightChevronButtonIcon, {
      color: BLUE_500,
      fontSize: 20,
      onPress: () => {
        onCardPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onCardPress)));
      }
    })]
  }));
};